import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import CardTable from "../../components/CardTable/CardTable";
import Button from "../../components/CustomButtons/Button.js";
import GenericModal from "../../components/GenericModal/GenericModal";
import { getDecimalFormat } from "../../helpers/getNumberFormats";
import { sendCommentsAction } from "../../redux/ducks/pipesSeries";
import { configTable, modalsConfig } from "./config";
import { ColumnContainer, FooterStyled, styles } from "./styles";

const useStyles = makeStyles(styles);

export const Details = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const isLoadingPipes = useSelector(
    (state) => state.pipesSeries.isLoadingPipes
  );
  const pipes = useSelector((state) => state.pipesSeries.pipes);
  const pipesTotal = useSelector((state) => state.pipesSeries.pipesTotal);
  const pipesPercentage = useSelector(
    (state) => state.pipesSeries.pipesPercentage
  );

  const [modals, setModals] = useState({
    item: null,
    message: false,
    text: "",
  });

  const handleCloseModals = (modal) => {
    setModals((prevState) => {
      return { ...prevState, [modal]: false };
    });
  };

  const handleOpenModals = (item, modal) => {
    setModals((prevState) => {
      return { ...prevState, item, [modal]: true };
    });
  };

  const handleChangeText = (event) => {
    const { value } = event.target;
    setModals((prevState) => ({
      ...prevState,
      item: {
        ...prevState.item,
        comments: value,
      },
    }));
  };

  const sendCommentsCallback = useCallback(() => {
    const { item } = modals;
    if (item) {
      dispatch(sendCommentsAction(item.id, { comments: item.comments }));
      setModals((prevState) => {
        return { ...prevState, message: false };
      });
    }
  }, [modals]);

  const getTrProps = (_state, rowInfo) => {
    if (rowInfo) {
      if (Number(rowInfo.row.percentage) < Number(rowInfo.row.min))
        return {
          style: {
            background: "#ffc7ce",
            color: "#a31746",
          },
        };
      if (Number(rowInfo.row.percentage) > Number(rowInfo.row.max))
        return {
          style: {
            background: "#ffeb9c",
            color: "#cc8526",
          },
        };
      return {};
    }
    return {};
  };

  const columns = [
    ...configTable,
    {
      Header: "Salida de pipa",
      Footer: <FooterStyled>Total:</FooterStyled>,
      id: "litersDiff",
      filterable: true,
      accessor: (data) => getDecimalFormat(data.litersDiff),
      filterMethod: (filter, row) =>
        String(row.litersDiff)
          .toLowerCase()
          .includes(filter.value.toLowerCase()),
    },
    {
      Header: "Diferencia",
      Footer: <FooterStyled>{getDecimalFormat(pipesTotal)}</FooterStyled>,
      id: "diff",
      filterable: true,
      accessor: (data) => getDecimalFormat(data.diff),
      filterMethod: (filter, row) =>
        String(row.diff)
          .toLowerCase()
          .includes(filter.value.toLowerCase()),
    },
    {
      Header: "Porcentaje % ",
      Footer: <FooterStyled>{pipesPercentage}</FooterStyled>,
      filterable: true,
      accessor: "percentage",
      filterMethod: (filter, row) =>
        String(row.percentage)
          .toLowerCase()
          .includes(filter.value.toLowerCase()),
    },
    {
      Header: "Min",
      accessor: "min",
      filterable: true,
      show: false,
    },
    {
      Header: "Max",
      accessor: "max",
      filterable: true,
      show: false,
    },
    {
      Header: "Acciones",
      accessor: "id",
      sortable: false,
      filterable: false,
      Cell: (props) => (
        <ColumnContainer>
          <Tooltip
            id="tooltip-top"
            title="Ver/editar comentario"
            placement="top"
          >
            <Button
              justIcon
              round
              simple
              size="sm"
              onClick={() =>
                handleOpenModals(props.original, modalsConfig.message)
              }
              color="info"
              className="edit"
            >
              <MessageIcon />
            </Button>
          </Tooltip>
        </ColumnContainer>
      ),
    },
  ].map((col) => {
    return {
      ...col,
      headerClassName: `${classes.thTable}`,
    };
  });

  return (
    <React.Fragment>
      <CardTable
        data={pipes}
        columns={columns}
        loading={isLoadingPipes}
        previousText="Anterior"
        nextText="Siguiente"
        noDataText="Sin datos"
        pageText="Pagina"
        ofText="de"
        getTrProps={getTrProps}
        resizable={false}
        rowsText="pipas"
      />
      <GenericModal
        title="Comentario"
        typeModal="message"
        subtitle={modals.item && modals.item.unit}
        item={modals.item}
        isOpen={modals.message}
        onChange={handleChangeText}
        value={modals.item ? modals.item.comments : ""}
        onCloseModal={handleCloseModals}
        onSubmit={sendCommentsCallback}
        isTextArea
      />
    </React.Fragment>
  );
};
